import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import CommonTable from '../../CommonTable/CommonTable';
import CustomPagination from '../../CustomPagination/CustomPagination';

import { updateCurrencyStatus, setBaseCurrency, updatePayoutCurrency } from '../../../actions/siteadmin/CurrencyManagement/currencyManagement';
import { managePaymentCurrency } from '../../../actions/siteadmin/CurrencyManagement/managePaymentCurrency';


import debounce from '../../../helpers/debounce';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './CurrencyManagement.css';
import messages from '../../../locale/jsonMessages';
class CurrencyManagement extends React.Component {

  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      symbol: PropTypes.string.isRequired,
      isEnable: PropTypes.bool.isRequired,
      isPayment: PropTypes.bool.isRequired,
      isBaseCurrency: PropTypes.bool.isRequired
    })),
    updateCurrencyStatus: PropTypes.any.isRequired,
    setBaseCurrency: PropTypes.any.isRequired,
    managePaymentCurrency: PropTypes.any.isRequired,
    title: PropTypes.string.isRequired,
  };

  static defaultProps = {
    data: []
  };

  handleSearchChange = (e) => {
    const { setStateVariable, refetch } = this.props;
    let variables = {
      currentPage: 1,
      searchList: e && e.toString().trim()
    };
    this.setState({ currentPage: 1 });
    setStateVariable(variables);
    refetch(variables);
  }
  paginationData = (currentPage) => {
    const { setStateVariable, refetch } = this.props;
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
  }

  async handleUpdateStatus(id, status, symbol) {
    const { updateCurrencyStatus, currentPage, searchList, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    updateCurrencyStatus(id, status, symbol, currentPage, searchList);
  }

  handleBaseCurrency = async (id, symbol) => {
    const { setBaseCurrency, currentPage, searchList, refetch, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await setBaseCurrency(id, symbol, currentPage, searchList);
    await refetch();
  }

  handleUpdatePayoutCurrency = async (id, symbol, isPayoutCurrency) => {
    const { updatePayoutCurrency, refetch, currentPage, searchList, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await updatePayoutCurrency({ id, symbol, isPayoutCurrency, currentPage, searchList });
    refetch();
  }

  handlePaymentCurrency = async (id, isPayment) => {
    const { managePaymentCurrency, refetch, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await managePaymentCurrency(id, isPayment);
    await refetch();
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.symbolLabel) },
      { data: formatMessage(messages.baseCurrencyLabel) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.setEnableDisable) },
      { data: formatMessage(messages.setCurrencyLabel) },
      { data: formatMessage(messages.allowedPaymentCurrency) },
      { data: formatMessage(messages.preferredPayoutCurrency) }
    ]
  };

  tbody = (props) => {
    const { data } = props;
    const { formatMessage } = this.props.intl;
    return data?.results?.map(value => {
      return {
        id: value?.id,
        data: [
          { data: value?.id },
          {
            data: value.symbol
          },
          {
            data: value.isBaseCurrency === true ? formatMessage(messages.activeLabel) : "-"
          },
          {
            data: <div> {value.isEnable ? formatMessage(messages.enabledLabel) : formatMessage(messages.disabledLabel)} </div>
          },
          {
            data: <div><a href="javascript:void(0)" onClick={() => this.handleUpdateStatus(value.id, value.isEnable, value?.symbol)} > {value.isEnable ? formatMessage(messages.disableLabel) : formatMessage(messages.enableLabel)} </a></div>
          },
          {
            data: <div>
              {
                (!value.isBaseCurrency && value.isEnable) ? <a href="javascript:void(0)" onClick={() => this.handleBaseCurrency(value.id, value.symbol)}>
                  <FormattedMessage  {...messages.setBaseCurrency} />
                </a> : "-"
              }
            </div>
          },
          {
            data: <div>
              {
                value.isEnable ? <a href="javascript:void(0)" onClick={() => this.handlePaymentCurrency(value?.id, value?.isPayment ? "remove" : "add")}>
                  {!value.isPayment ? <FormattedMessage  {...messages.addLabel} /> : <FormattedMessage  {...messages.remove} />}
                </a> : "-"
              }
            </div>
          },
          {
            data: <div>
              {value?.isPayoutCurrency ? <span>{formatMessage(messages.activeLabel)} </span> : (value?.isEnable ? <a href="javascript:void(0)" onClick={() => this.handleUpdatePayoutCurrency(value?.id, value?.symbol, value?.isPayoutCurrency)}>
                <FormattedMessage  {...messages.setPreferredCurrency} />
              </a> : "-")}
            </div>
          },
        ]
      }
    })
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { data, currentPage } = this.props;
    return (
      <div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.manageCurrency)}
          isSearch
          onSearch={(e) => debounce(this.handleSearchChange(e.target.value))}
        />
        {
          data?.results?.length > 0
          && <div>
            <CustomPagination
              total={data?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.currency)}
            />
          </div>
        }
      </div>

    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  updateCurrencyStatus,
  setBaseCurrency,
  managePaymentCurrency,
  updatePayoutCurrency,
  demoRestriction
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(CurrencyManagement)));